(() => {
  if (window.__omHybridAddToCartInitialized) {
    return;
  }

  window.__omHybridAddToCartInitialized = true;

  const SESSION_KEY =
    'om-full-cart-notification-shown-v1';

  const TOAST_DURATION = 4000;

  const ADD_BUTTON_SELECTOR = [
    'button[name="add"]',
    '.product-form__submit',
    '.quick-add__submit'
  ].join(', ');

  const CART_ICON_SELECTOR = [
    '#cart-icon-bubble',
    '.header__icon--cart',
    'a[href$="/cart"]'
  ].join(', ');

  const THRESHOLDS = {
    delivery: 99900,
    om5: 129900,
    om10: 199900,
    om20: 349900
  };

  let fullPopupShownInMemory = false;
  let lastAddButton = null;
  let toastTimer = null;

  function hasShownFullPopup() {
    if (fullPopupShownInMemory) {
      return true;
    }

    try {
      return (
        sessionStorage.getItem(SESSION_KEY) ===
        'true'
      );
    } catch (error) {
      return fullPopupShownInMemory;
    }
  }

  function markFullPopupShown() {
    fullPopupShownInMemory = true;

    try {
      sessionStorage.setItem(
        SESSION_KEY,
        'true'
      );
    } catch (error) {
      /* In-memory fallback is enough. */
    }
  }

  function formatMoney(paise) {
    const rupees = Math.max(
      0,
      Math.ceil(Number(paise || 0) / 100)
    );

    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0
    }).format(rupees);
  }

  function getBenefitMessage(total) {
    if (total < THRESHOLDS.delivery) {
      return (
        `${formatMoney(
          THRESHOLDS.delivery - total
        )} more for complimentary delivery`
      );
    }

    if (total < THRESHOLDS.om5) {
      return (
        `Delivery unlocked · ${formatMoney(
          THRESHOLDS.om5 - total
        )} more for 5% off`
      );
    }

    if (total < THRESHOLDS.om10) {
      return (
        `OM5 available · ${formatMoney(
          THRESHOLDS.om10 - total
        )} more for 10% off`
      );
    }

    if (total < THRESHOLDS.om20) {
      return (
        `OM10 available · ${formatMoney(
          THRESHOLDS.om20 - total
        )} more for 20% off`
      );
    }

    return 'Your highest cart-value benefit is available';
  }

  function getShopRoot() {
    return (
      window.Shopify?.routes?.root || '/'
    );
  }

  async function fetchCart() {
    const response = await fetch(
      `${getShopRoot()}cart.js`,
      {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error(
        'Unable to retrieve cart.'
      );
    }

    return response.json();
  }

  function getCartIcon() {
    return document.querySelector(
      CART_ICON_SELECTOR
    );
  }

  function positionToastBelowHeader(toast) {
  if (!toast) {
    return;
  }

  const isMobile = window.matchMedia(
    '(max-width: 749px)'
  ).matches;

  const header =
    document.querySelector('sticky-header') ||
    document.querySelector('.header-wrapper') ||
    document.querySelector('header');

  /*
    Keep the toast safely inside the visible viewport,
    even when the page is scrolled and the browser toolbar
    changes height.
  */
  const minimumTop = isMobile ? 84 : 12;
  const maximumHeaderBottom = isMobile
    ? 180
    : window.innerHeight * 0.45;

  let top = minimumTop;

  if (header) {
    const rect = header.getBoundingClientRect();

    if (
      rect.bottom > 0 &&
      rect.bottom < maximumHeaderBottom
    ) {
      top = Math.max(
        minimumTop,
        rect.bottom + 10
      );
    }
  }

  toast.style.setProperty(
    '--om-cart-toast-top',
    `${Math.round(top)}px`
  );
}

  function createToast() {
    let toast = document.querySelector(
      '[data-om-cart-toast]'
    );

    if (toast) {
      return toast;
    }

    toast = document.createElement('div');

    toast.className = 'om-cart-toast';

    toast.setAttribute(
      'data-om-cart-toast',
      ''
    );

    toast.setAttribute(
      'role',
      'status'
    );

    toast.setAttribute(
      'aria-live',
      'polite'
    );

    toast.innerHTML = `
      <div
        class="om-cart-toast__check"
        aria-hidden="true"
      >
        <svg
          viewBox="0 0 24 24"
          width="19"
          height="19"
          fill="none"
        >
          <path
            d="M5 12.5L9.3 16.5L19 6.8"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </svg>
      </div>

      <div class="om-cart-toast__content">
        <strong class="om-cart-toast__title">
          Added to Kanha Ji’s Seva Basket
        </strong>

        <span
          class="om-cart-toast__benefit"
          data-om-cart-toast-benefit
        ></span>
      </div>

      <a
        href="${getShopRoot()}cart"
        class="om-cart-toast__action"
      >
        View Cart
      </a>

      <span
        class="om-cart-toast__timer"
        aria-hidden="true"
      ></span>
    `;

    document.body.appendChild(toast);

    return toast;
  }

  function hideToast() {
    const toast = document.querySelector(
      '[data-om-cart-toast]'
    );

    if (!toast) {
      return;
    }

    toast.classList.remove('is-visible');
  }

  async function showCompactToast() {
    const toast = createToast();

    positionToastBelowHeader(toast);

    const benefitText = toast.querySelector(
      '[data-om-cart-toast-benefit]'
    );

    try {
      const cart = await fetchCart();

      if (benefitText) {
        benefitText.textContent =
          getBenefitMessage(
            cart.total_price
          );
      }
    } catch (error) {
      if (benefitText) {
        benefitText.textContent =
          'Your cart has been updated';
      }
    }

    window.clearTimeout(toastTimer);

    /*
      Restart the progress animation even if additions
      happen quickly one after another.
    */
    toast.classList.remove('is-visible');

    void toast.offsetWidth;

    toast.classList.add('is-visible');

/*
  Recalculate after rendering because mobile browsers
  can resize the visible viewport while scrolling.
*/
window.requestAnimationFrame(() => {
  positionToastBelowHeader(toast);
});

window.setTimeout(() => {
  if (toast.classList.contains('is-visible')) {
    positionToastBelowHeader(toast);
  }
}, 250);

toastTimer = window.setTimeout(
  hideToast,
  TOAST_DURATION
);
  }

  function animateAddButton() {
    if (
      !lastAddButton ||
      !document.contains(lastAddButton)
    ) {
      return;
    }

    lastAddButton.classList.remove(
      'om-add-trigger-success'
    );

    void lastAddButton.offsetWidth;

    lastAddButton.classList.add(
      'om-add-trigger-success'
    );

    window.setTimeout(() => {
      lastAddButton?.classList.remove(
        'om-add-trigger-success'
      );
    }, 700);
  }

  function animateCartIcon() {
    const cartIcon = getCartIcon();

    if (!cartIcon) {
      return;
    }

    cartIcon.classList.remove(
      'om-cart-icon-pulse'
    );

    void cartIcon.offsetWidth;

    cartIcon.classList.add(
      'om-cart-icon-pulse'
    );

    window.setTimeout(() => {
      cartIcon.classList.remove(
        'om-cart-icon-pulse'
      );
    }, 800);
  }

  function animateDotToCart() {
    const cartIcon = getCartIcon();

    if (
      !cartIcon ||
      !lastAddButton ||
      !document.contains(lastAddButton) ||
      !lastAddButton.animate
    ) {
      animateCartIcon();
      return;
    }

    const startRect =
      lastAddButton.getBoundingClientRect();

    const endRect =
      cartIcon.getBoundingClientRect();

    const dot =
      document.createElement('span');

    dot.className = 'om-cart-fly-dot';

    dot.style.left =
      `${startRect.left +
      startRect.width / 2 - 7}px`;

    dot.style.top =
      `${startRect.top +
      startRect.height / 2 - 7}px`;

    document.body.appendChild(dot);

    const deltaX =
      endRect.left +
      endRect.width / 2 -
      (
        startRect.left +
        startRect.width / 2
      );

    const deltaY =
      endRect.top +
      endRect.height / 2 -
      (
        startRect.top +
        startRect.height / 2
      );

    const animation = dot.animate(
      [
        {
          transform:
            'translate(0, 0) scale(1)',
          opacity: 1
        },
        {
          transform:
            `translate(${deltaX * 0.55}px, ${
              deltaY * 0.35 - 35
            }px) scale(0.85)`,
          opacity: 1,
          offset: 0.55
        },
        {
          transform:
            `translate(${deltaX}px, ${deltaY}px) scale(0.35)`,
          opacity: 0.25
        }
      ],
      {
        duration: 680,
        easing:
          'cubic-bezier(0.22, 0.8, 0.25, 1)',
        fill: 'forwards'
      }
    );

    animation.addEventListener(
      'finish',
      () => {
        dot.remove();
        animateCartIcon();
      },
      {
        once: true
      }
    );
  }

  function runSuccessAnimation() {
    animateAddButton();
    animateDotToCart();
  }

  document.addEventListener(
    'click',
    (event) => {
      const addButton = event.target.closest(
        ADD_BUTTON_SELECTOR
      );

      if (
        !addButton ||
        addButton.disabled ||
        addButton.getAttribute(
          'aria-disabled'
        ) === 'true'
      ) {
        return;
      }

      lastAddButton = addButton;
    },
    true
  );

  /*
    Patch Dawn's existing notification only after its
    custom element has been registered.
  */
  customElements
    .whenDefined('cart-notification')
    .then(() => {
      const CartNotification =
        customElements.get(
          'cart-notification'
        );

      if (
        !CartNotification ||
        CartNotification.prototype
          .__omHybridPatched
      ) {
        return;
      }

      const originalOpen =
        CartNotification.prototype.open;

      if (
        typeof originalOpen !== 'function'
      ) {
        return;
      }

      CartNotification.prototype.open =
        function (...args) {
          runSuccessAnimation();

          if (!hasShownFullPopup()) {
            markFullPopupShown();

            return originalOpen.apply(
              this,
              args
            );
          }

          /*
            Do not open the large notification again.
            Show the non-blocking top confirmation instead.
          */
          showCompactToast();

          return undefined;
        };

      CartNotification.prototype
        .__omHybridPatched = true;
    });

  window.addEventListener(
    'resize',
    () => {
      const toast = document.querySelector(
        '[data-om-cart-toast].is-visible'
      );

      if (toast) {
        positionToastBelowHeader(toast);
      }
    }
  );
})();